import Axios from "axios"/* import React from "react"; */
import { sortCaret } from "../../../_metronic/_helpers";

//const url_users = "http://localhost:5000/gt-out/us-central1/api/v2/users-marketing";
const url_users = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v2/users-marketing";

export const columns = [
  {
    dataField: "name",
    text: "Name",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "email",
    text: "Email",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "phone",
    text: "Phone",
    sort: true,
sortCaret: sortCaret,
  },
  {
    dataField: "work_type",
    text: "Type",
    sort: true,
sortCaret: sortCaret,
  }
  // {
  //   dataField: "company_id",
  //   text: "Company",
  //   sort: true,
  // }
];
/* function StatusColumnFormatter(cellContent, row) {
  return <span className={!row?.docheck ? "text-danger" : "text-success"}>{row?.docheck ? "verified" : "not verified"}</span>;
} */

export function getClients(setClients) {
  Axios.get(`${url_users}/find`)
    .then((res) => {
      const EMPLOYEES = res.data.payload;
      console.log(EMPLOYEES);
      setClients(EMPLOYEES);
    })
    .catch(function (thrown) {
      if (Axios.isCancel(thrown)) {
          console.log(`request cancelled:${thrown.message}`)
      } else {
          console.log('another error happened')
      }
  })}
export function getClient(uid) {
  return Axios.get(`${url_users}/find/${uid}`);
}
export function updateClient(EMPLOYEE) {
  if (EMPLOYEE.uid) {
    return Axios.put(`${url_users}/update/${EMPLOYEE.uid}`, EMPLOYEE);
  } else {
    return Axios.post(`${url_users}/create`, {...EMPLOYEE, emailVerified: true});
  }
}
export function deleteClient(uid) {
  return Axios.delete(`${url_users}/delete/${uid}`);
}